import ReactDOM from 'react-dom';

function RootPortal({children}) {
    return (
        ReactDOM.createPortal(
            children,
            document.body,
        )
    );
}

export { RootPortal };
